import { Fragment, MutableRefObject } from "react";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Badge, Col, Collapse, Row } from "reactstrap";
import { Href } from "../../../Constants/Constants";
import { MediaSectionsData } from "../../../Data/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";
import { setMedia } from "../../../ReduxToolkit/Reducers/Messenger/AppSidebar";
import { dynamicImage } from "../../../Utils";

const SharedMedia = () => {
  const dispatch = useAppDispatch();
  const { mediaOpen } = useAppSelector((state) => state.appSidebar);
  return (
    <div className="media-gallery portfolio-section grid-portfolio">
      {MediaSectionsData.slice(3).map((section, index) => (
        <div className="collapse-block open" key={index}>
          <h5 className="block-title" onClick={() => dispatch(setMedia(index))}>Shared Media
            <Badge color="primary" className="sm ms-2">{section.badgeCount}</Badge>
          </h5>
          <Collapse isOpen={mediaOpen[index]}>
            <div className="block-content">
              <Row className="share-media zoom-gallery gy-4">
                <Gallery>
                  <div className="col-12">
                    <h6 className="mb-2">22/03/2024</h6>
                  </div>
                  {section.images.map((image, index) => (
                    <Fragment key={index}>
                      {
                        index === 3 &&
                        <div className="col-12">
                          <h6 className="mb-2">22/03/2024</h6>
                        </div>
                      }
                      <Col xs="4" className={`${index + 1 === 1 ? "isotopeSelector filter" : ""}`}>
                        <div className={`media-${image.mediaClass} ${index + 1 !== 1 ? "isotopeSelector filter" : ""}`}>
                          <div className="overlay">
                            <div className="border-portfolio">
                              <Item original={dynamicImage(`gallery/${image.src}.jpg`)} width="90" height="150">
                                {({ ref, open }) => (
                                  <a href={Href} onClick={open} className="bg-img">
                                    <div className="overlay-background"><i className="ti-plus" /></div>
                                    <img className="img-fluid bg-img" ref={ref as unknown as MutableRefObject<HTMLImageElement>} src={dynamicImage(`gallery/${image.src}.jpg`)} alt="portfolio-image" />
                                  </a>
                                )}
                              </Item>
                            </div>
                          </div>
                        </div>
                        {image.Children &&
                          image.Children.map((image, index) => (
                            <div className={`media-${image.mediaClass} isotopeSelector filter`} key={index}>
                              <div className="overlay">
                                <div className="border-portfolio">
                                  <Item original={dynamicImage(`gallery/${image.src}.jpg`)} width="90" height="150">
                                    {({ ref, open }) => (
                                      <a href={Href} onClick={open}>
                                        <div className="overlay-background"><i className="ti-plus" /></div>
                                        <img className="img-fluid bg-img" ref={ref as unknown as MutableRefObject<HTMLImageElement>} src={dynamicImage(`gallery/${image.src}.jpg`)} alt="portfolio-image" />
                                      </a>
                                    )}
                                  </Item>
                                </div>
                              </div>
                            </div>
                          ))}
                      </Col>
                    </Fragment>
                  ))}
                </Gallery>
              </Row>
            </div>
          </Collapse>
        </div>
      ))}
    </div>
  );
};

export default SharedMedia;
